import axios from 'axios';
import { apiUrl } from '../constants';

const publicApi = axios.create({
  baseURL: apiUrl.HOST,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

export default publicApi;
